export default __webpack_public_path__ + "static/media/icn_camera.78cc0a02.svg";